import http from '../http';
import { POFFICE_API } from '@/config/env';
import { AUTH_KEYS } from '@/constants';
import { jwtDecode } from 'jwt-decode';

export const getpoffice = (id: number) => http.get(`${POFFICE_API}/${id}`);

export const getpoffices = () => http.get(`${POFFICE_API}`);

export const getpofficesFullResponse = () =>
  http.get(`${POFFICE_API}`, { returnFullResponse: true });

export const createpoffice = (poffice: any) =>
  http.post(`${POFFICE_API}`, poffice, { returnFullResponse: true });

export const hasUsedOffice = async (pOfficeId: number) => {
  return await http.get(`${POFFICE_API}/${pOfficeId}/in-use`);
};
